import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './EasyPost.frontend.types'

@Injectable({ providedIn: 'root' })
export class EasyPost_create_address_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { address?: { street1?: string, street2?: string, city?: string, state?: string, zip?: string, country?: string, company?: string, phone?: string, name?: string }, verify?: boolean, verify_strict?: boolean, easyPostKey: string }): Promise<{ address_id?: string, errors?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.easyPostKey)) {
      missingRequiredInParams.push('\'easyPostKey\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/EasyPost/functions/create_address_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

